import { Roles } from "features/panelManagement/accessManagement/types/access";
import { AuthAction, AuthActionTypes } from "features/auth/types/actions";

const initialState: {
    isLoggedIn: boolean;
    hasLoaded: boolean;
    role: Roles;
    uid: string;
} = {
    isLoggedIn: false,
    hasLoaded: false,
    role: Roles.USER,
    uid: "",
};

const authReducer = (
    state = initialState,
    action: AuthActionTypes
): typeof initialState => {
    switch (action.type) {
        case AuthAction.LOGIN_USER:
            return {
                ...state,
                isLoggedIn: true,
                hasLoaded: true,
                role: action.role,
                uid: action.uid,
            };
        case AuthAction.LOGOUT_USER:
            return {
                ...state,
                isLoggedIn: false,
                hasLoaded: true,
                uid: "",
            };
        default:
            return state;
    }
};

export default authReducer;
